export const createSearchBreadcrumbs = ({
  homeTranslation,
  homeLink,
  searchTermTranslation,
  searchTerm,
}) => [
  { friendlyName: homeTranslation, linkUrl: `${homeLink}/?hrd=1` },
  { friendlyName: `${searchTermTranslation} ${searchTerm}` },
];

export default createSearchBreadcrumbs;
